import { Moment } from 'moment'
import { ITimeslot, ETimeslotType } from '@/store/apis/timeslots'

export enum ECellColor {
  OutsideRange = '#6e6e6e',
  Default = '#32B579',
  Disabled = '#A9A9A9',
  Important = '#ED9E15',
  Required = '#a12be0',
  User = '#D50001',
  Scene = '#17bae3',
  OtherScene = '#1564ed',
}

export const getTimeslotColor = (timeslot?: ITimeslot): ECellColor => {
  if (timeslot) {
    if (!timeslot.sceneId && !timeslot.sceneGroupId && !timeslot.userId) {
      switch (timeslot.type) {
        case ETimeslotType.Disabled:
          return ECellColor.Disabled
        case ETimeslotType.Important:
          return ECellColor.Important
        case ETimeslotType.Required:
          return ECellColor.Required
      }
    }
    if (timeslot.userId) {
      return ECellColor.User
    }
    if (timeslot.userId) {
      return ECellColor.Scene
    }
  }
  return ECellColor.OutsideRange
}

export const getTimeslotTypeColor = (type: ETimeslotType): ECellColor => {
  switch (type) {
    case ETimeslotType.Disabled:
      return ECellColor.Disabled
    case ETimeslotType.Important:
      return ECellColor.Important
    case ETimeslotType.Required:
      return ECellColor.Required
    // TODO: Something iffy here
    // case ETimeslotType.User:
    //     return ECellColor.User
    // case ETimeslotType.Scene:
    //     return ECellColor.Scene
  }
}

export enum EDragType {
  Top = 'TOP',
  Middle = 'MIDDLE',
  Bottom = 'BOTTOM',
}

export enum EBadgeType {
  Scene = 'SCENE',
  User = 'USER',
}

export interface IScaleInterval {
  start: Moment
  end: Moment
  placeId?: number
  comment?: string
  color?: ECellColor
}

export interface IExistingScaleInterval extends IScaleInterval {
  id: number
  including?: string[]
  excluding?: string[]
}

export interface ICellConfig {
  color: string
  startTimestamp: Moment
  disabled?: boolean
  comment?: string
  disableHover?: boolean
  isStart?: boolean
  isEnd?: boolean
  badge?: {
    type: EBadgeType
    contents: {
      label: string
      comment: string
    }[]
  }
}

export interface IColumnDimension {
  width: number
}

export interface IExceptions {
  includes: number[]
  excludes: number[]
}
